export default function getSrcSetImageUtil (src) {
  return `${src} 2x`
}
